import React, { useMemo, useState } from 'react';
import { GenericModal } from 'components/Modals/GenericModal';
import { icons } from 'assets/icons/index'
import { Radio } from 'components/inputs/Radio/Radio';
import { Vertical } from 'gls';

type ImportConfirmationModalProps = {
  onClose: () => void;
  onImport: (isCreateMode: boolean) => void;
  selectedCount: number
};

export const ImportConfirmationModal = ({
  onClose,
  onImport,
  selectedCount
}: ImportConfirmationModalProps) => {

  const [value, setValue] = useState<"import" | "create">("import");
  const importOptions = useMemo(() => {
    const list = [{ key: 'Import only', value: 'import' }]
    if (selectedCount === 1)
      list.push({ key: 'Import & Create Asset', value: 'create' })
    return list
  }, [selectedCount])

  const handleImport = () => {
    onImport(value === "create")
  }

  return (
    <GenericModal
      icon={<icons.ImportIcon aria-label="Import Beacons" />}
      roundIconStyle={false}
      title="Import Beacons"
      isOpen
      actionName='Confirm'
      onAction={handleImport}
      onCancel={onClose}
    >
      <Vertical>
        <span>Please select the action you want to take:</span>
        <Radio
          direction='vertical'
          value={value}
          options={importOptions}
          onChange={(value) => setValue(value)} />
      </Vertical>
    </GenericModal>

  );
}
